const USER_ROLES = {
  admin: 'admin',
  user: 'user',
};

export default USER_ROLES;
